import { t } from "i18next";
import * as yup from "yup";

export const marketingTemplateSchema = yup.object({
  name: yup
    .string()
    .required(t("Template name is required"))
    .matches(
      /^[a-z0-9_]+$/,
      t("Lowercase letters, numbers and underscores only")
    ),
  language: yup.string().required(t("Language is required")),
  category: yup.string().required(t("Category is required")),
  bodyText: yup.string().required(t("Message body is required")),
  variableCount: yup
    .number()
    .typeError(t("Must be a number"))
    .integer(t("Must be a whole number"))
    .min(0, t("Cannot be negative"))
    .required(t("Variable count is required"))
});
